import React from 'react';
import { RightOutlined } from '@ant-design/icons';
import { Tooltip } from 'antd';
import { ActionButtonsContainer, BuyButtonWrapper } from './ActionButtons.styled';
import {
  DetailsButton,
  BuyButton,
  IconButton,
  CartButton,
} from '../../atoms/Buttons';
import { DollarIcon, ShoppingCartIcon, ApartmentIcon } from '../../atoms/Icons';

export interface ActionButtonsProps {
  onDetailsClick?: () => void;
  onBuyClick?: () => void;
  onAddToCart?: () => void;
  onCompositionClick?: () => void;
  showCompositionButton?: boolean;
  disabled?: boolean;
  isLoading?: boolean;
  layout?: 'default' | 'stacked';
  detailsTextDesktop?: string | null;
  detailsTextMobile?: string | null;
  buyText?: string | null;
  addToCartText?: string | null;
  disableBuyButton?: boolean;
}

export function ActionButtons({
  onDetailsClick,
  onBuyClick,
  onAddToCart,
  onCompositionClick,
  showCompositionButton = false,
  disabled = false,
  isLoading = false,
  layout = 'default',
  detailsTextDesktop = 'Abrir Detalhes',
  detailsTextMobile = 'Detalhes | GFP',
  buyText = 'Comprar',
  addToCartText = 'Adicionar ao Carrinho',
  disableBuyButton = false,
}: ActionButtonsProps) {
  const isStacked = layout === 'stacked';

  return (
    <ActionButtonsContainer className={`actions-buttons ${layout}`}>
      <div className={isStacked ? 'stacked-row full-width' : 'inline-button'}>
        <DetailsButton
          onClick={onDetailsClick}
          disabled={disabled}
          className="detail-button small"
        >
          {detailsTextDesktop && (
            <span className="button-text-desktop">{detailsTextDesktop}</span>
          )}
          {detailsTextMobile && (
            <span className="button-text-mobile">{detailsTextMobile}</span>
          )}
          <RightOutlined />
        </DetailsButton>
      </div>

      <div className={isStacked ? 'stacked-row split-width' : 'inline-buttons'}>
        <Tooltip
          title={
            disableBuyButton
              ? 'Comprar agora não disponível para ofertas ENP'
              : ''
          }
          style={{ flex: 1 }}
        >
          <BuyButtonWrapper className="buy-button-wrapper">
            <BuyButton
              onClick={onBuyClick}
              disabled={disabled || disableBuyButton}
              className={`buy-button text-button ${
                !buyText?.length ? 'small' : ''
              }`}
            >
              {!!(buyText && buyText.length) && (
                <span className="flexible-text">{buyText}</span>
              )}
              <DollarIcon />
            </BuyButton>
          </BuyButtonWrapper>
        </Tooltip>

        <CartButton
          onClick={onAddToCart}
          disabled={disabled || isLoading}
          loading={isLoading}
          className="cart-button icon-button"
        >
          {addToCartText && (
            <span className="button-cart-text-desktop">{addToCartText}</span>
          )}
          <ShoppingCartIcon />
        </CartButton>

        {onCompositionClick && showCompositionButton && (
          <IconButton
            onClick={onCompositionClick}
            disabled={disabled}
            className="icon-button"
          >
            <ApartmentIcon />
          </IconButton>
        )}
      </div>
    </ActionButtonsContainer>
  );
}
